import { Component, OnInit, ViewChild, Inject, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';

import { User } from '@app/core';
import * as fromStore from '@app/core/store';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-user-lookup',
  templateUrl: './user-lookup.component.html',
  styleUrls: ['./user-lookup.component.scss']
})
export class UserLookupComponent implements OnInit, OnDestroy {
  users$ = this.store.select(fromStore.selectUsers);
  subscription: Subscription; 
  dataSource: MatTableDataSource<User> | null;
  displayedColumns = ['fullName', 'userName',  'actions'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private store: Store<fromStore.State>,
    public dialogRef: MatDialogRef<UserLookupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.store.dispatch(new fromStore.LoadUsers())
    this.subscription = this.users$.subscribe(users => {
      if (users) {
        this.dataSource = new MatTableDataSource<User>(users);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/components/user-lookup/user-lookup.component.ts